import { fmtMsg, MessageHelper, NotificationType, Progress } from "@/commonui";
import { Spinner } from "@/commonui/store/modules/spinner";
import { Container, VcFooter, VcHeader, VcSplash } from "@/components/layout";
import AppNavigation from "@/components/navigation/app-navigation/app-navigation.vue";
import Unauthorized from "@/components/unauthorized/unauthorized.vue";
import VersionManagement from "@/components/version-management/version-management.vue";
import AppBreadcrumb from "@/components/bread-crumb/bread-crumb.vue";
import AppSettings from "@/modules/app-settings";
import { VersionGroupModule } from "@/modules/versiongroup";
import { SettingService, VersionGroupService } from "@/services";
import { AppViewMode, ContentStatus, VcsMenuCategory, VcsMenuCategoryPermission } from "@/util/enum";
import { isLinkVisible, versionsLoaded } from "@/util/func";
import { Layout } from "ant-design-vue";
import Vue from "vue";
import { Component, Watch, Ref } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { AuthService, OidcLogin } from "../commonui";
import { AppNavigationRef } from "@/components/navigation/app-navigation/app-navigation";
import { cloneDeep } from "lodash";
import { VcsLocale } from "@/locales/localeid";
import { ResponseHelper } from "@/util/helper";

const { Content } = Layout;
@Component({
	components: {
		Layout,
		LayoutContent: Content,
		VcSplash,
		VcFooter,
		VcHeader,
		AppNavigation,
		Unauthorized,
		VersionManagement,
		Progress,
		Container,
		AppBreadcrumb
	}
})
export default class App extends Vue {
	public appSetting = getModule(AppSettings);
	public spinModule = getModule(Spinner);
	public oidcModule = getModule(OidcLogin);
	public appViewMode = AppViewMode;
	public loading = true;
	public loadingVersions = true;
	private versionGroupFetchInterval: NodeJS.Timeout | undefined = undefined;

	@Ref() readonly appNavigationCompRef!: AppNavigationRef;

	changeSelectedMainMenu() {
		this.appNavigationCompRef.setParentSelectedMenu();
	}

	@Watch("currentLocale")
	reRender() {
		this.$forceUpdate();
	}

	@Watch("isSignedIn")
	getVersionGroups() {
		// get all the versions and user setting
		if (this.isSignedIn) {
			if (!this.loading) {
				this.loading = true;
			}
			VersionGroupModule.refreshVersionGroup(false).then(() => {
				VersionGroupService()
					.getVcsSettings()
					.then((selected) => {
						VersionGroupModule.setGsVersion(selected.selectedGSVersion);
						VersionGroupModule.setLsVersion(selected.selectedLSVersion);
						setTimeout(() => VersionGroupModule.setLoading({ loading: false }), 100);
						if (this.loading) {
							this.loading = false;
						}
						this.loadingVersions = false;
					})
					.catch((reason) => {
						if (ResponseHelper.isForbiddenResponse(reason)) {
							this.loading = false;
						}
					});
			});
		}
	}

	created() {
		this.setRouterEvents();
		AuthService.localSilentLogin();
		this.setAppSettings();
	}

	get vcsMenuCategory() {
		return VcsMenuCategory;
	}

	get vcsMenuPermissionCategory() {
		return VcsMenuCategoryPermission;
	}
	get isSignedIn() {
		return this.oidcModule.loginInfo?.loggedin;
	}

	get isUnauthorized(): boolean {
		return this.appSetting.mode === AppViewMode.UnAuthorized;
	}
	get isAuthorized(): boolean {
		return this.appSetting.mode === AppViewMode.Authorized;
	}

	setRouterEvents(): void {
		this.$router.beforeEach(async (to, from, next) => {
			this.loading = true;
			await versionsLoaded();
			next();
		});
		this.$router.afterEach((to, from) => {
			this.loading = false;
		});
	}

	showSection(menuId: VcsMenuCategory, permissionId?: VcsMenuCategoryPermission, superMenuId?: VcsMenuCategory) {
		return isLinkVisible(menuId, permissionId, superMenuId);
	}

	private setAppSettings() {
		SettingService.getSettings().then((data) => {
			this.appSetting.setAppSettings(data);
		});
	}
}
